module.exports = __webpack_public_path__ + "img/icon-giftbox-button.4e6c4a75.svg";